/**
 * Payment timing constants for the evening / clock-off money loop (Prompt H).
 *
 * Collection clock-off. Floor managers collect ALL payments (segregation of
 * duties) and clock off at 6pm, so everybody is paid by 6pm: any session
 * starting at or after this hour has its client collected and its artist paid
 * by 6pm, before the session starts.
 *
 * DISTINCT from SETTLEMENT_CUTOFF_HOUR (17, in sessionFlow.ts): that governs the
 * banking-lump / `afterCutoff` stamp, a different concept. Do not merge them.
 * // ASSUMPTION: banking lump cutoff stays 5pm while collection clock-off is 6pm - verify with client.
 */
export const CLOCKOFF_HOUR = 18;

/**
 * True when an ISO instant's hour (in its own offset) is at or after the
 * clock-off - i.e. an evening session. Uses the same char-slice idiom as
 * `hourOfIso` in sessionFlow.ts so evening detection agrees with the settlement
 * stamp rather than drifting via Date parsing.
 */
export function isEveningStartIso(iso: string): boolean {
  return Number(iso.slice(11, 13)) >= CLOCKOFF_HOUR;
}
